import { Link } from "@tanstack/react-router";
import { Home, LogIn, ShieldAlert } from "lucide-react";

import { Button } from "@pbz/ui-kit";

import { HOME_ROUTE } from "@/utils/constants";

const Unauthorized = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
      <div className="mb-6">
        <ShieldAlert className="h-16 w-16 text-amber-500 mx-auto" />
      </div>
      <h1 className="text-3xl font-bold mb-2">Access Denied</h1>
      <p className="text-gray-600 mb-8 max-w-md">
        You don't have permission to access this page. Please contact your
        administrator if you believe this is an error.
      </p>
      <div className="flex">
        <Link to={HOME_ROUTE}>
          <Button className="border-2 border-blue-500 text-blue-500 flex-item items-center gap-2 mr-2">
            <Home className="h-4 w-4" />
            Back to Lead List
          </Button>
        </Link>
        <Link to="/login">
          <Button className="border-2 border-orange-500 text-orange-500 flex-item items-center gap-2">
            <LogIn className="h-4 w-4" />
            Login Again
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
